import {
  GET_USAGE_DASHBOARD_URL,
  GET_SUMMARY_URL,
  GET_LIFETIME_USAGE_URL,
  GET_ORGANIZATION_SUMMARY_URL,
} from "@/config/apiEndpoints";
import apiRequest from "@/utils/apiRequest";
export const state = {
  graphs: {},
  summary: [],
  lifetimeUsage: null,
  orgOverview: null,
};

export const getters = {
  graphs: (state) => state.graphs,
  summary: (state) => state.summary,
  lifetimeUsage: (state) => state.lifetimeUsage,
  orgOverview: (state) => state.orgOverview,
};

export const mutations = {
  STORE_GRAPHS(state, graphs) {
    state.graphs = graphs;
  },
  STORE_SUMMARY(state) {
    state.loading = true;
    state.summary = [];
  },
  STORE_SUMMARY_SUCCESS(state, summary) {
    state.loading = false;
    state.summary = summary;
  },
  STORE_SUMMARY_FAILED(state) {
    state.summary = [];
    state.loading = false;
  },
  STORE_LIFETIME_USAGE(state, lifetimeUsage) {
    state.lifetimeUsage = lifetimeUsage;
  },
  STORE_ORG_OVERVIEW(state, orgOverview) {
    state.orgOverview = orgOverview;
  },
};

export const actions = {
  getOrganizationSummary({ commit }, params) {
    commit("STORE_SUMMARY");
    return new Promise((resolve, reject) => {
      apiRequest({
        url: GET_SUMMARY_URL,
        method: "GET",
        params: { ...params },
      })
        .then((res) => {
          commit("STORE_SUMMARY_SUCCESS", res.data);
          resolve(res.data);
        })
        .catch((err) => {
          commit("STORE_SUMMARY_FAILED");
          reject(err);
        });
    });
  },

  getOrganizationOverview({ commit }, params) {
    return new Promise((resolve, reject) => {
      apiRequest({
        url: GET_ORGANIZATION_SUMMARY_URL,
        method: "GET",
        params: { ...params },
      })
        .then((res) => {
          commit("STORE_ORG_OVERVIEW", res.data);
          resolve(res.data);
        })
        .catch((err) => {
          commit("STORE_ORG_OVERVIEW", null);
          reject(err);
        });
    });
  },

  getLifetimeUsage({ commit }, params) {
    return new Promise((resolve, reject) => {
      apiRequest({
        url: GET_LIFETIME_USAGE_URL,
        method: "GET",
        params: { ...params },
      })
        .then((res) => {
          commit("STORE_LIFETIME_USAGE", res.data);
          resolve(res.data);
        })
        .catch((err) => {
          commit("STORE_LIFETIME_USAGE", null);
          reject(err);
        });
    });
  },

  getDashboardGraphs({ commit }, reqData) {
    const { queryParams, body } = reqData;
    if (!queryParams.start_date || !queryParams.end_date) return;

    queryParams.start_date = convertDateToAcceptedString(
      queryParams.start_date
    );
    queryParams.end_date = convertDateToAcceptedString(queryParams.end_date);

    return new Promise((resolve, reject) => {
      apiRequest({
        url: GET_USAGE_DASHBOARD_URL,
        method: "POST",
        params: {
          ...queryParams,
        },
        data: body,
      })
        .then((res) => {
          const graph = res.data["Graph"];
          const graphData = {
            consumptionGraph: serializeGraphData(graph["consumption_graph"]),
            errorGraph: serializeGraphData(graph["error_graph"]),
          };
          commit("STORE_GRAPHS", graphData);
          resolve(graphData);
        })
        .catch((err) => {
          commit("STORE_GRAPHS", {});
          reject(err);
        });
    });
  },
};

function convertDateToAcceptedString(inputDate) {
  const date = new Date(inputDate);
  return `${date.getFullYear()}-${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${date.getDate().toString().padStart(2, "0")}`;
}

function serializeGraphData(graphData) {
  const result = {};
  if (!graphData) {
    return result;
  }
  const consumptiondata = new Map(Object.entries(graphData));
  consumptiondata.forEach((value, key) => {
    const splittedKey = key.trim().split(":");
    let newKey = splittedKey[0];
    if (splittedKey.length > 2) {
      newKey = `${newKey} | ${splittedKey[3]}`;
    } else {
      newKey = newKey + " | All";
    }
    if (Object.keys(value.data).length > 0) {
      if (!result[newKey]) {
        result[newKey] = value;
      } else {
        result[newKey] += value;
      }
    }
  });
  return result;
}
